interface TicketStatusBadgeProps {
  color: string;
  text?: string;
}
export const TicketStatusBadge = ({ color, text }: TicketStatusBadgeProps) => (
  <div
    className="flex h-8 w-fit items-center justify-center rounded-md px-2 text-sm font-normal"
    style={{ backgroundColor: color }}
  >
    {text}
  </div>
);
